export default class Header {
    constructor() {
        if (Electro.DEBUG) {
            console.info('Header.constructor()');
        }

    Header.updateMenu();
  }

    static updateMenu() {
        if (Electro.DEBUG) {
            console.info('Header.updateMenu()');
        }

        console.info('FreshStep.isShelter: ', FreshStep.isShelter);

        if (FreshStep.isShelter === true) {
            $('.js-menu-item--donate a').html('Shelters');
        }
    }
}
